import { Converter, getClientPortalBaseUrls, productionEnvName } from '@itm/shared-frontend/lib/utils';

import getEnvVariable from './getEnvVariable';

import {
  AuditAction,
  PolicyStatus,
  PolicyAuditType,
  EntityConfigurationAuditType,
  SchemeConfigurationType,
  SelectOption,
  TargetPlatform,
  TemplateStatus,
  TemplateType,
  UntanglerAnalysisLevel,
} from 'src/types';

export const ENV_PREFIX = 'REACT_APP_' as const;

export const ENVIRONMENT = getEnvVariable('ENVIRONMENT');
export const TARGET_PLATFORM = getEnvVariable('TARGET_PLATFORM');
export const AUTH_API_URL = getEnvVariable('AUTH_API_URL');
export const FLEXPORTAL_API_URL = getEnvVariable('FLEXPORTAL_API_URL');
export const CLIENT_PORTAL_API_URL = getEnvVariable('CLIENT_PORTAL_API_URL');

export const isProductionEnv = ENVIRONMENT === productionEnvName;
export const isAzureTargetPlatform = TARGET_PLATFORM === TargetPlatform.AZURE;

export const { clientPortalDomain, clientPortalLoginUrl, clientPortalDashboardUrl } =
  getClientPortalBaseUrls(ENVIRONMENT);

export const disableInvalidCharsInputToNumberField = (event: React.KeyboardEvent<any>) => {
  const invalidCharList = ['-', '+', 'e'];
  if (invalidCharList.includes(event.key.toLowerCase())) event.preventDefault();
};

export const disableScrollOnNumberField = (event: React.WheelEvent<HTMLInputElement>) => {
  (event.target as HTMLInputElement).blur();
};

export const templateStatusOptions = Converter.enumToSelectOptions(TemplateStatus);
export const untanglerAnalysisLevelOptions = Converter.enumToSelectOptions(UntanglerAnalysisLevel);
export const untanglerAnalysisLevelOptionsToDisplay = Converter.enumToSelectOptions(UntanglerAnalysisLevel).filter(
  ({ value }) => value !== UntanglerAnalysisLevel.Debug,
);
export const benefitAnalysisLevelOptionsToDisplay = [
  { value: UntanglerAnalysisLevel.Error, label: 'Error' },
  { value: UntanglerAnalysisLevel.Warning, label: 'Warning' },
];
export const templateTypeOptions = Converter.enumToSelectOptions(TemplateType);
export const policyStatusOptions = Converter.enumToSelectOptions(PolicyStatus);
export const auditActionOptions = Converter.enumToSelectOptions(AuditAction);
export const policyAuditTypeOptions = Converter.enumToSelectOptions(PolicyAuditType);
export const entityConfigurationAuditTypeOptions = Converter.enumToSelectOptions(EntityConfigurationAuditType);
export const schemeConfigurationTypeOptions = Converter.enumToSelectOptions(SchemeConfigurationType);

export const policyRenewalMonthFrequencyOptions: SelectOption[] = [
  { value: '12', label: '12 months' },
  { value: '18', label: '18 months' },
  { value: '24', label: '24 months' },
];

export const UNDERWRITING_ERROR_CODES = new Set([
  'OVER_FCL',
  'OVER_PAB',
  'NO_TEMP',
  'TEMP_COVER',
  'ACCEPTED',
  'POSTPONED',
  'DECLINED',
  'RESTRICTED',
]);

export const UNDERWRITING_REQUIRED_CODES = new Set(['OVER_FCL', 'OVER_PAB']);
